module.exports = __webpack_public_path__ + "img/order.0ff2a4e9.svg";